import client from './api-client';

export const getExcel= async(query) => {
    try {
        
        const response = await client.get(`gestion/monitor-360/xlsx?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return response.data.file
               
            
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}